import { send } from '../../../../../../src/network';
import { type CustomerProductRating } from '../../../../../../src/types/CustomerProductRating';

export { type CustomerProductRating };

export type ProductPayload = Pick<
  CustomerProductRating,
  'product' | 'liked' | 'order'
>;

export async function postApiV2CustomersCustomerIdProductRatings(
  customerId: number,
  requestBody: ProductPayload
) {
  return await send<CustomerProductRating>({
    path: `/api/v2/customers/${customerId}/product_ratings/`,
    method: 'POST',
    body: requestBody,
  });
}
